import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Button } from '@spikemark/ui/components/design-system/button';
import { DialogContent, DialogTitle } from '@spikemark/ui/components/ui/dialog';
import PromoImg from '@/public/images/taylor-made-promo.jpg';
import { ServerConfig } from '@/core/server-config';
export const TaylorMadeDialogContent: FC = () => <DialogContent data-sentry-element="DialogContent" data-sentry-component="TaylorMadeDialogContent" data-sentry-source-file="taylor-made-dialog-content.tsx">
    <DialogTitle className="text-2xl font-bold mb-4" data-sentry-element="DialogTitle" data-sentry-source-file="taylor-made-dialog-content.tsx">Welcome College Coaches</DialogTitle>
    <p className="mb-4">
      TaylorMade is providing exclusive access to a discount program for all Clippd college coach
      members and their teams.
    </p>
    <Image alt="Taylor Made Promo" src={PromoImg} width={940} height={487} className="w-full aspect-auto" data-sentry-element="Image" data-sentry-source-file="taylor-made-dialog-content.tsx" />
    <p className="my-4">Please click below and follow the instructions to activate your account.</p>
    <div className="flex justify-center">
      <Button variant="primary" asChild data-sentry-element="Button" data-sentry-source-file="taylor-made-dialog-content.tsx">
        <Link href={ServerConfig.taylorMadeUrl} target="_blank" data-sentry-element="Link" data-sentry-source-file="taylor-made-dialog-content.tsx">
          Activate Account
        </Link>
      </Button>
    </div>
  </DialogContent>;